(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tracks = document.querySelectorAll('[data-announcement-track]');
    tracks.forEach((track) => {
      const group = track.firstElementChild;
      if (!group || !group.children.length) return;
      if (track.dataset.cloned === 'true') return;
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      track.dataset.cloned = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cards = document.querySelectorAll('[data-blog-card]');
    if (!cards.length) return;
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      cards.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const siblings = Array.from(el.parentElement.children).filter((n) =>
            n.hasAttribute('data-blog-card')
          );
          const index = siblings.indexOf(el);
          el.style.setProperty('--delay', index * 100 + 'ms');
          el.classList.add('is-visible');
          observer.unobserve(el);
        });
      },
      { threshold: 0.1 }
    );
    cards.forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    const DRAWER_NAME = 'cart-drawer';

    const getDrawer = () => document.querySelector('[data-drawer="' + DRAWER_NAME + '"]');

    // Résout le wrapper en remontant depuis le drawer (compat section group qui change l'ID)
    const getWrapper = () => {
      const drawer = getDrawer();
      if (!drawer) return null;
      return drawer.closest('[id^="shopify-section"]');
    };

    const ANIM_MS = 540;

    const openDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.remove('is-closing');
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
      // Force le drawer à partir off-screen, puis trigger la transition au frame suivant
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          drawer.classList.add('is-open');
        });
      });
    };

    const closeDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.classList.add('is-closing');
      // Attend la fin de l'animation avant de fermer le dialog
      setTimeout(() => {
        drawer.classList.remove('is-closing');
        if (typeof drawer.close === 'function') drawer.close();
        else drawer.removeAttribute('open');
      }, ANIM_MS);
    };

    const replaceDrawerHtml = (html, openAfter) => {
      const wrapper = getWrapper();
      if (!wrapper) return;
      const temp = document.createElement('div');
      temp.innerHTML = html.trim();
      const newWrapper = temp.querySelector('#' + (wrapper.id || '__none__')) || temp.firstElementChild;
      if (newWrapper) {
        wrapper.innerHTML = newWrapper.innerHTML;
        refreshCartCount();
        if (openAfter) requestAnimationFrame(openDrawer);
      }
    };

    // Met à jour tous les badges [data-cart-count] (header, etc.) hors du drawer.
    const updateCartCount = (count) => {
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      syncCartTotalFromDrawer(count);
    };

    // Synchronise les éléments [data-cart-total] (header) avec le total formaté
    // rendu par Liquid dans le drawer. Évite tout formatage côté JS.
    const syncCartTotalFromDrawer = (count) => {
      const els = document.querySelectorAll('[data-cart-total]');
      if (!els.length) return;
      const source = document.querySelector('.cart-drawer__subtotal-amount');
      const formatted = source ? source.textContent.trim() : '';
      els.forEach((el) => {
        if (formatted) el.textContent = formatted;
        if (typeof count === 'number') {
          if (count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        }
      });
    };

    // Récupère cart.js après chaque mutation pour synchroniser le compteur,
    // au cas où la mutation actuelle n'aurait pas renvoyé item_count.
    const refreshCartCount = async () => {
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!r.ok) return;
        const c = await r.json();
        updateCartCount(c.item_count);
      } catch (e) { /* noop */ }
    };

    window.cartDrawerOpen = openDrawer;
    window.cartDrawerReplace = replaceDrawerHtml;
    window.cartDrawerUpdateCount = updateCartCount;
    window.cartDrawerRefreshCount = refreshCartCount;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-drawer-open="' + DRAWER_NAME + '"]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }
      const drawer = getDrawer();
      if (!drawer || !drawer.open) return;
      const closer = event.target.closest('[data-drawer-close]');
      if (closer && drawer.contains(closer)) {
        closeDrawer();
        return;
      }
      if (event.target === drawer) closeDrawer();
    });

    document.addEventListener('click', async (event) => {
      const btn = event.target.closest('[data-cross-sell-add]');
      if (!btn) return;
      const drawer = getDrawer();
      if (!drawer || !drawer.contains(btn)) return;
      event.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.setAttribute('disabled', '');
      btn.textContent = '…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections: [DRAWER_NAME]
          })
        });
        if (!res.ok) throw new Error('add-failed');
        const data = await res.json();
        if (data.sections && data.sections[DRAWER_NAME]) {
          replaceDrawerHtml(data.sections[DRAWER_NAME], true);
        } else {
          window.location.reload();
        }
        refreshCartCount();
        window.dispatchEvent(new CustomEvent('cart-updated'));
      } catch (e) {
        btn.removeAttribute('disabled');
        btn.textContent = '+';
      }
    });

    document.addEventListener('click', async (event) => {
      const link = event.target.closest('.cart-drawer__remove');
      if (!link) return;
      const drawer = getDrawer();
      if (!drawer || !drawer.contains(link)) return;
      event.preventDefault();
      const item = link.closest('.cart-drawer__item');
      const keyEl = item && item.querySelector('[data-cart-line-key]');
      if (!keyEl) { window.location.href = link.href; return; }
      link.style.opacity = '0.4';
      link.style.pointerEvents = 'none';
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: keyEl.value, quantity: 0, sections: [DRAWER_NAME] })
        });
        if (!res.ok) throw new Error('remove-failed');
        const data = await res.json();
        if (data.sections && data.sections[DRAWER_NAME]) {
          replaceDrawerHtml(data.sections[DRAWER_NAME], drawer.open);
        } else {
          window.location.reload();
        }
        if (typeof data.item_count === 'number') updateCartCount(data.item_count);
        else refreshCartCount();
        window.dispatchEvent(new CustomEvent('cart-updated'));
      } catch (e) {
        window.location.reload();
      }
    });

    let qtyTimer = null;
    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      const drawer = getDrawer();
      if (!drawer || !drawer.contains(input)) return;
      const item = input.closest('.cart-drawer__item');
      if (!item) return;
      const keyEl = item.querySelector('[data-cart-line-key]');
      if (!keyEl) return;
      const key = keyEl.value;
      const quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) return;

      clearTimeout(qtyTimer);
      qtyTimer = setTimeout(async () => {
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: [DRAWER_NAME] })
          });
          if (!res.ok) throw new Error('change-failed');
          const data = await res.json();
          if (data.sections && data.sections[DRAWER_NAME]) {
            replaceDrawerHtml(data.sections[DRAWER_NAME], drawer.open);
          } else {
            window.location.reload();
          }
          if (typeof data.item_count === 'number') updateCartCount(data.item_count);
          else refreshCartCount();
          window.dispatchEvent(new CustomEvent('cart-updated'));
        } catch (e) {
          window.location.reload();
        }
      }, 350);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'cookie-consent-given';
    const banner = document.querySelector('[data-cookie-banner]');
    const modal = document.querySelector('[data-cookie-modal]');
    if (!banner || !modal) return;

    const closeBtn = banner.querySelector('[data-cookie-close]');
    const acceptBtn = banner.querySelector('[data-cookie-accept-all]');
    const rejectBtn = banner.querySelector('[data-cookie-reject-all]');
    const customizeBtn = banner.querySelector('[data-cookie-customize]');
    const overlay = modal.querySelector('[data-cookie-modal-overlay]');
    const modalCloseBtn = modal.querySelector('[data-cookie-modal-close]');
    const saveBtn = modal.querySelector('[data-cookie-save]');
    const cancelBtn = modal.querySelector('[data-cookie-cancel]');
    const toggleAnalytics = modal.querySelector('[data-cookie-toggle-analytics]');
    const toggleMarketing = modal.querySelector('[data-cookie-toggle-marketing]');

    let prevFocus = null;

    function readStored() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (_e) {
        return null;
      }
    }

    function writeStored(consent) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          sale_of_data: !!consent.sale_of_data,
          timestamp: Date.now(),
        }));
      } catch (_e) {
        /* localStorage unavailable — silently degrade */
      }
    }

    function showBanner() {
      banner.hidden = false;
      requestAnimationFrame(() => banner.classList.add('is-visible'));
    }

    function hideBanner() {
      banner.classList.remove('is-visible');
      window.setTimeout(() => { banner.hidden = true; }, 320);
    }

    function openModal() {
      const stored = readStored();
      if (stored) {
        toggleAnalytics.checked = !!stored.analytics;
        toggleMarketing.checked = !!stored.marketing;
      }
      prevFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      const heading = modal.querySelector('.cookie-modal__heading');
      if (heading) heading.setAttribute('tabindex', '-1');
      window.setTimeout(() => {
        if (heading) heading.focus();
      }, 100);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      window.setTimeout(() => { modal.hidden = true; }, 240);
      document.body.style.overflow = '';
      if (prevFocus && typeof prevFocus.focus === 'function') {
        prevFocus.focus();
      }
    }

    function applyConsent(consent) {
      const payload = {
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: !!consent.analytics,
        sale_of_data: !!consent.sale_of_data,
      };
      const persist = () => writeStored(consent);

      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(payload, persist);
        } catch (_e) {
          persist();
        }
      } else {
        persist();
      }
    }

    function checkAndShow() {
      let shouldShow = false;
      try {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowGDPRBanner === 'function') {
          shouldShow = window.Shopify.customerPrivacy.shouldShowGDPRBanner();
        } else {
          shouldShow = !readStored();
        }
      } catch (_e) {
        shouldShow = !readStored();
      }
      if (shouldShow) showBanner();
    }

    function bootstrap() {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([
          { name: 'consent-tracking-api', version: '0.1' }
        ], () => { checkAndShow(); });
      } else {
        checkAndShow();
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', () => {
      applyConsent({ analytics: false, marketing: false, sale_of_data: false });
      hideBanner();
    });

    if (acceptBtn) acceptBtn.addEventListener('click', () => {
      applyConsent({ analytics: true, marketing: true, sale_of_data: false });
      hideBanner();
    });

    if (rejectBtn) rejectBtn.addEventListener('click', () => {
      applyConsent({ analytics: false, marketing: false, sale_of_data: false });
      hideBanner();
    });

    if (customizeBtn) customizeBtn.addEventListener('click', () => {
      openModal();
    });

    if (saveBtn) saveBtn.addEventListener('click', () => {
      applyConsent({
        analytics: toggleAnalytics ? toggleAnalytics.checked : false,
        marketing: toggleMarketing ? toggleMarketing.checked : false,
        sale_of_data: false,
      });
      closeModal();
      hideBanner();
    });

    if (cancelBtn) cancelBtn.addEventListener('click', () => closeModal());
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', () => closeModal());
    if (overlay) overlay.addEventListener('click', () => closeModal());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    window.addEventListener('cookie-banner:open', () => {
      if (banner.hidden) {
        showBanner();
      }
      openModal();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const grid = document.querySelector('[data-brands-grid]');
    if (!grid) return;
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      grid.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(grid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-featured-products]');
    if (!sections.length) return;

    const prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
      const track = section.querySelector('[data-featured-track]');
      if (!track) return;

      const items = track.querySelectorAll('[data-featured-item]');
      const prevBtn = section.querySelector('[data-featured-prev]');
      const nextBtn = section.querySelector('[data-featured-next]');

      // Prev/Next nav — scroll one card-width per click
      const stepSize = () => {
        const first = items[0];
        if (!first) return track.clientWidth * 0.8;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
        return first.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        if (!prevBtn || !nextBtn) return;
        const max = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= max;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: stepSize(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateButtons);
      }, { passive: true });

      window.addEventListener('resize', updateButtons);
      updateButtons();

      // Optional autoplay (disabled by default)
      if (track.dataset.autoplay) {
        const interval = parseInt(track.dataset.autoplay, 10) || 5000;
        let paused = false;
        let timer = null;
        const start = () => {
          if (timer) return;
          timer = setInterval(() => {
            if (paused) return;
            const max = track.scrollWidth - track.clientWidth;
            if (track.scrollLeft >= max - 4) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: stepSize(), behavior: 'smooth' });
            }
          }, interval);
        };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
        section.addEventListener('mouseenter', () => { paused = true; });
        section.addEventListener('mouseleave', () => { paused = false; });
        document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });
        start();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cookie-manage]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('cookie-banner:open'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const announcement = document.querySelector('.announcement-bar');
    const root = document.documentElement;
    const body = document.body;
    let ticking = false;

    const measureAnnouncement = () => {
      const h = announcement ? announcement.offsetHeight : 0;
      root.style.setProperty('--announcement-height', h + 'px');
    };

    measureAnnouncement();
    window.addEventListener('resize', measureAnnouncement, { passive: true });

    if (window.ResizeObserver && announcement) {
      new ResizeObserver(measureAnnouncement).observe(announcement);
    }

    const updateScroll = () => {
      const currentY = window.scrollY;
      body.classList.toggle('header-group-scrolled', currentY > 0);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateScroll);
        ticking = true;
      }
    }, { passive: true });

    updateScroll();

    // Wishlist counter
    const WISHLIST_KEY = 'ad-parfumerie-wishlist';
    const wishlistBadge = document.querySelector('[data-wishlist-count]');

    const readWishlistCount = () => {
      try {
        const list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return Array.isArray(list) ? list.length : 0;
      } catch (e) {
        return 0;
      }
    };

    const refreshWishlistBadge = () => {
      if (!wishlistBadge) return;
      const count = readWishlistCount();
      wishlistBadge.textContent = count;
      if (count > 0) {
        wishlistBadge.removeAttribute('hidden');
      } else {
        wishlistBadge.setAttribute('hidden', '');
      }
    };

    refreshWishlistBadge();
    window.addEventListener('wishlist-updated', refreshWishlistBadge);
    window.addEventListener('storage', (e) => {
      if (e.key === WISHLIST_KEY) refreshWishlistBadge();
    });

    // Bouton langue flottant : ferme au clic en dehors
    const localeFab = document.querySelector('[data-locale-fab]');
    if (localeFab) {
      document.addEventListener('click', (e) => {
        if (localeFab.open && !localeFab.contains(e.target)) localeFab.removeAttribute('open');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hero-media]').forEach(function (media) {
      var slides = media.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;
      var hero = media.closest('.hero');
      var dotsRoot = hero ? hero.querySelector('[data-hero-dots]') : null;
      var dots = dotsRoot ? dotsRoot.querySelectorAll('[data-hero-dot]') : [];
      var interval = parseInt(media.dataset.autoplay, 10) || 5000;
      if (interval < 1500) interval = 1500;
      var index = 0;
      var paused = false;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setActive(newIndex) {
        if (newIndex === index) return;
        slides[index].classList.remove('is-active');
        if (dots[index]) {
          dots[index].classList.remove('is-active');
          dots[index].setAttribute('aria-selected', 'false');
        }
        index = (newIndex + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) {
          dots[index].classList.add('is-active');
          dots[index].setAttribute('aria-selected', 'true');
        }
      }

      function advance() {
        if (paused) return;
        setActive(index + 1);
      }

      var timer = null;
      function start() {
        if (prefersReducedMotion) return;
        if (timer) clearInterval(timer);
        timer = setInterval(advance, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      start();

      media.addEventListener('mouseenter', function () { paused = true; });
      media.addEventListener('mouseleave', function () { paused = false; });

      // Click sur dot → saute à la slide et reset le timer
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.dataset.heroDot, 10);
          if (isNaN(i)) return;
          setActive(i);
          start();
        });
      });

      // Pause quand l'onglet est inactif → économie batterie
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-collection-page]');
    if (!root) return;

    const baseUrl = root.dataset.collectionBase || window.location.pathname.split('/').slice(0, 3).join('/');
    const sectionId = root.dataset.sectionId;
    const TAG_VALUES = new Set(['femme','homme','mixte','unisexe','floral','boise','frais','gourmand','ambres','fruite']);

    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
    let backdrop = null;
    const ensureBackdrop = () => {
      if (backdrop) return backdrop;
      backdrop = document.createElement('div');
      backdrop.className = 'collection-page__backdrop';
      root.appendChild(backdrop);
      backdrop.addEventListener('click', closeSidebar);
      return backdrop;
    };
    const openSidebar = () => {
      const sidebar = root.querySelector('[data-collection-sidebar]');
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      ensureBackdrop().classList.add('is-active');
      document.body.style.overflow = 'hidden';
    };
    const closeSidebar = () => {
      const sidebar = root.querySelector('[data-collection-sidebar]');
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    /* ---------- AJAX filter engine ---------- */

    // Read current state from window.location and build the filter target URL
    const buildTargetUrl = (overrides) => {
      // overrides: { tagsToggle?: 'femme', formData?: FormData, sort?: string }
      overrides = overrides || {};

      // Parse current tags from path: /collections/parfums/femme+floral
      const path = window.location.pathname.replace(/\/$/, '');
      const baseClean = baseUrl.replace(/\/$/, '');
      let tagSegment = '';
      if (path.indexOf(baseClean) === 0) {
        const after = path.slice(baseClean.length).replace(/^\//, '');
        if (after) tagSegment = after;
      }
      let tagSet = new Set();
      if (tagSegment) {
        tagSegment.split('+').forEach((t) => { if (t) tagSet.add(decodeURIComponent(t)); });
      }

      // Apply tag toggle
      if (overrides.tagsToggle) {
        const t = overrides.tagsToggle;
        if (tagSet.has(t)) tagSet.delete(t);
        else tagSet.add(t);
      }

      // Build new path with tags
      const tagsArr = Array.from(tagSet).filter(Boolean);
      let newPath = baseClean;
      if (tagsArr.length > 0) newPath += '/' + tagsArr.map(encodeURIComponent).join('+');

      // Build query string
      const qs = new URLSearchParams();
      const currentParams = new URLSearchParams(window.location.search);
      // Preserve sort_by
      if (overrides.sort != null) {
        if (overrides.sort) qs.set('sort_by', overrides.sort);
      } else {
        const cs = currentParams.get('sort_by');
        if (cs) qs.set('sort_by', cs);
      }
      // Apply form filters (overrides) or preserve existing filter.* params
      if (overrides.formData) {
        for (const [key, value] of overrides.formData.entries()) {
          if (key.indexOf('filter.') === 0 && value !== '' && value != null) {
            qs.append(key, value);
          }
        }
      } else {
        currentParams.forEach((v, k) => {
          if (k.indexOf('filter.') === 0) qs.append(k, v);
        });
      }

      // Préserve "show" (nombre affiché par page, appliqué par collection-filters.js)
      const showParam = currentParams.get('show');
      if (showParam) qs.set('show', showParam);

      const queryStr = qs.toString();
      return newPath + (queryStr ? '?' + queryStr : '');
    };

    // Fetch section HTML and swap into root
    let fetchToken = 0;
    const navigate = async (targetUrl) => {
      const myToken = ++fetchToken;
      root.classList.add('is-loading');
      try {
        const url = new URL(targetUrl, window.location.origin);
        const fetchUrl = new URL(targetUrl, window.location.origin);
        if (sectionId) fetchUrl.searchParams.set('section_id', sectionId);

        const res = await fetch(fetchUrl.toString(), { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('fetch failed: ' + res.status);
        const html = await res.text();
        // Stale response guard
        if (myToken !== fetchToken) return;

        // Parse and extract the .collection-page section
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('[data-collection-page]');
        if (!newRoot) throw new Error('no collection-page in response');

        // Swap inner content (preserve the root element + its listeners)
        root.innerHTML = newRoot.innerHTML;

        // Update browser URL without reload
        history.pushState({}, '', url.toString());

        // Smooth scroll to top of grid on small screens
        if (!isDesktop()) {
          const main = root.querySelector('.collection-page__main');
          if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (e) {
        // Fallback to full reload on any error
        console.error('[collection] AJAX failed, falling back to reload', e);
        window.location.assign(targetUrl);
      } finally {
        if (myToken === fetchToken) root.classList.remove('is-loading');
      }
    };

    // Browser back/forward
    window.addEventListener('popstate', () => {
      navigate(window.location.pathname + window.location.search);
    });

    /* ---------- Event delegation (survives DOM swap) ---------- */

    // Pill clicks (tag toggle)
    root.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-tag-pill]');
      if (pill) {
        e.preventDefault();
        const tag = pill.dataset.tagPill;
        if (!tag) return;
        const url = buildTargetUrl({ tagsToggle: tag });
        navigate(url);
        return;
      }

      const opener = e.target.closest('[data-open-sidebar]');
      if (opener) { openSidebar(); return; }
      const closer = e.target.closest('[data-close-sidebar]');
      if (closer) { closeSidebar(); return; }

      const clear = e.target.closest('.collection-page__filter-clear');
      if (clear) {
        e.preventDefault();
        navigate(baseUrl);
        return;
      }

      // Active-filter chip remove buttons (top of grid)
      const removeChip = e.target.closest('.collection-page__active-remove');
      if (removeChip && removeChip.href) {
        e.preventDefault();
        navigate(removeChip.getAttribute('href'));
      }
    });

    // Form: filter changes (checkboxes, radios, price inputs)
    let priceDebounce = null;
    root.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;

      // Sort dropdown
      if (t.matches('[data-collection-sort]')) {
        const url = buildTargetUrl({ sort: t.value });
        navigate(url);
        return;
      }

      const form = t.closest('[data-collection-filter-form]');
      if (!form) return;

      // Skip pill-as-anchor (handled by click)
      if (t.dataset && t.dataset.tagPill) return;

      const fire = () => {
        const fd = new FormData(form);
        const url = buildTargetUrl({ formData: fd });
        navigate(url);
      };

      if (t.type === 'checkbox' || t.type === 'radio') {
        fire();
      } else if (t.matches('input[name^="filter.v.price"]')) {
        clearTimeout(priceDebounce);
        priceDebounce = setTimeout(fire, 500);
      }
    });

    // Submit (via Enter key on form, or "Appliquer" button)
    root.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-collection-filter-form]');
      if (!form) return;
      e.preventDefault();
      const fd = new FormData(form);
      navigate(buildTargetUrl({ formData: fd }));
    });

    // Recherche live dans la liste Maison (client-side, pas de navigation)
    const normMaison = (s) =>
      (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    root.addEventListener('input', (e) => {
      const search = e.target.closest('[data-maison-search]');
      if (!search) return;
      const q = normMaison(search.value);
      const group = search.closest('details') || root;
      const list = group.querySelector('.collection-page__maison-list');
      if (!list) return;
      const rows = list.querySelectorAll('.collection-page__maison-option');
      let visible = 0;
      rows.forEach((row) => {
        const nameEl = row.querySelector('.collection-page__maison-name');
        const name = normMaison(nameEl ? nameEl.textContent : row.textContent);
        const match = q === '' || name.indexOf(q) !== -1;
        row.style.display = match ? '' : 'none';
        if (match) visible += 1;
      });
      let empty = list.querySelector('.collection-page__maison-empty');
      if (visible === 0) {
        if (!empty) {
          empty = document.createElement('p');
          empty.className = 'collection-page__maison-empty';
          empty.textContent = search.dataset.maisonEmptyText || 'Aucune maison trouvée';
          list.appendChild(empty);
        }
      } else if (empty) {
        empty.remove();
      }
    });
    // Empêche Enter dans la recherche maison de soumettre le formulaire (filtre client-side)
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.closest('[data-maison-search]')) {
        e.preventDefault();
      }
    });

    // Esc to close sidebar
    document.addEventListener('keydown', (e) => {
      const sidebar = root.querySelector('[data-collection-sidebar]');
      if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
    });

    window.addEventListener('resize', () => {
      const sidebar = root.querySelector('[data-collection-sidebar]');
      if (isDesktop() && sidebar && sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
    });

    // Init price slider on first load + after each AJAX swap (mutationobserver)
    const initPriceSlider = (range) => {
      if (range.dataset.priceInited) return;
      range.dataset.priceInited = '1';
      const min = parseInt(range.dataset.priceMin, 10) || 0;
      const max = parseInt(range.dataset.priceMax, 10) || 500;
      const lowSlider = range.querySelector('[data-price-slider="low"]');
      const highSlider = range.querySelector('[data-price-slider="high"]');
      const lowInput = range.querySelector('[data-price-input="low"]');
      const highInput = range.querySelector('[data-price-input="high"]');
      const fill = range.querySelector('[data-price-fill]');
      if (!lowSlider || !highSlider || !lowInput || !highInput || !fill) return;
      const span = max - min;
      if (span <= 0) return;
      const updateFill = () => {
        const lo = parseInt(lowSlider.value, 10);
        const hi = parseInt(highSlider.value, 10);
        const lp = ((lo - min) / span) * 100;
        const hp = ((hi - min) / span) * 100;
        fill.style.left = lp + '%';
        fill.style.width = Math.max(0, hp - lp) + '%';
      };
      const clamp = (n, lo, hi) => Math.min(Math.max(n, lo), hi);
      // Trigger AJAX after slider release / input commit
      const fireFilter = () => {
        const form = lowInput.closest('[data-collection-filter-form]');
        if (!form) return;
        const fd = new FormData(form);
        navigate(buildTargetUrl({ formData: fd }));
      };
      let sliderDebounce = null;
      const debouncedFire = () => {
        clearTimeout(sliderDebounce);
        sliderDebounce = setTimeout(fireFilter, 350);
      };

      // Sync input when slider moves; empty input when at default extremes (so
      // form serialization skips them and we don't filter unnecessarily)
      const syncLowInput = () => {
        const v = parseInt(lowSlider.value, 10);
        lowInput.value = v <= min ? '' : v;
      };
      const syncHighInput = () => {
        const v = parseInt(highSlider.value, 10);
        highInput.value = v >= max ? '' : v;
      };
      lowSlider.addEventListener('input', () => {
        let v = parseInt(lowSlider.value, 10);
        const hi = parseInt(highSlider.value, 10);
        if (v >= hi) { v = Math.max(min, hi - 1); lowSlider.value = v; }
        syncLowInput();
        updateFill();
      });
      highSlider.addEventListener('input', () => {
        let v = parseInt(highSlider.value, 10);
        const lo = parseInt(lowSlider.value, 10);
        if (v <= lo) { v = Math.min(max, lo + 1); highSlider.value = v; }
        syncHighInput();
        updateFill();
      });
      // Slider 'change' (mouse release) → instant filter
      lowSlider.addEventListener('change', fireFilter);
      highSlider.addEventListener('change', fireFilter);
      // Number input typing → debounced filter
      lowInput.addEventListener('input', () => {
        const v = lowInput.value === '' ? min : parseInt(lowInput.value, 10);
        if (!isNaN(v)) lowSlider.value = clamp(v, min, max);
        updateFill();
        debouncedFire();
      });
      highInput.addEventListener('input', () => {
        const v = highInput.value === '' ? max : parseInt(highInput.value, 10);
        if (!isNaN(v)) highSlider.value = clamp(v, min, max);
        updateFill();
        debouncedFire();
      });
      updateFill();
    };
    const initSliders = () => {
      root.querySelectorAll('[data-price-range]').forEach(initPriceSlider);
    };
    initSliders();

    /* Client-side filter is now handled by assets/collection-filters.js
     * (loaded as <script src="..."> at the bottom of the section template
     * to bypass compiled_assets/scripts.js cache invalidation issues).
     */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-kit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-kit-composer]');
    if (!root) return;

    const targetCount = parseInt(root.dataset.targetCount || '3', 10);
    const kitPriceCents = parseInt(root.dataset.kitPriceCents || '0', 10);
    const currency = root.dataset.currency || 'EUR';

    const list = root.querySelector('[data-kit-selected-list]');
    const emptyState = root.querySelector('[data-kit-empty-state]');
    const countEl = root.querySelector('[data-kit-count]');
    const progressEl = root.querySelector('[data-kit-progress]');
    const fillEl = root.querySelector('[data-kit-progress-fill]');
    const submit = root.querySelector('[data-kit-submit]');
    const ctaText = root.querySelector('[data-kit-cta-text]');
    const hiddenHandles = root.querySelector('[data-kit-selected-handles]');
    const hiddenVariants = root.querySelector('[data-kit-selected-variants]');
    const samplesTotalEl = root.querySelector('[data-kit-samples-total]');
    const savingsRow = root.querySelector('[data-kit-savings]');
    const savingsAmount = root.querySelector('[data-kit-savings-amount]');
    const form = root.querySelector('[data-kit-form]');

    const selected = [];

    const formatMoney = (cents) => {
      const value = (parseInt(cents, 10) || 0) / 100;
      return value.toLocaleString('fr-FR', { style: 'currency', currency, minimumFractionDigits: 2 });
    };

    const i18nCtaRemainingOther = root.dataset.i18nCtaRemainingOther || 'Sélectionnez {remaining} parfums supplémentaires';
    const i18nCtaRemainingOne = root.dataset.i18nCtaRemainingOne || 'Sélectionnez encore 1 parfum';
    const i18nCtaReady = root.dataset.i18nCtaReady || 'Composer mon kit · Ajouter au panier';
    const i18nRemoveLabel = root.dataset.i18nRemoveLabel || 'Retirer du kit';

    const labelDisabled = (remaining) =>
      remaining > 1
        ? i18nCtaRemainingOther.replace('{remaining}', remaining)
        : i18nCtaRemainingOne;
    const labelReady = i18nCtaReady;

    const renderSelected = () => {
      if (!list) return;
      const items = list.querySelectorAll('[data-kit-selected-item]');
      items.forEach((el) => el.remove());
      if (selected.length === 0) {
        if (emptyState) emptyState.removeAttribute('hidden');
      } else {
        if (emptyState) emptyState.setAttribute('hidden', '');
        selected.forEach((item) => {
          const li = document.createElement('li');
          li.className = 'kit-composer__selected-item';
          li.setAttribute('data-kit-selected-item', '');
          li.innerHTML =
            '<span class="kit-composer__selected-item-text">' +
            (item.vendor ? '<span class="kit-composer__selected-item-vendor">' + item.vendor + '</span>' : '') +
            item.title +
            '</span>' +
            '<span class="kit-composer__selected-item-price">' + formatMoney(item.priceCents) + '</span>' +
            '<button type="button" class="kit-composer__selected-remove" data-kit-remove="' +
            item.handle +
            '" aria-label="' + i18nRemoveLabel.replace(/"/g, '&quot;') + '">' +
            '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
            '<path d="M2 2l6 6M8 2l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
            '</svg>' +
            '</button>';
          list.appendChild(li);
        });
      }
    };

    const update = () => {
      const count = selected.length;
      if (countEl) countEl.textContent = String(count);
      if (progressEl) progressEl.setAttribute('aria-valuenow', String(count));
      if (fillEl) {
        const pct = Math.min(100, (count / targetCount) * 100);
        fillEl.style.width = pct + '%';
      }

      if (hiddenHandles) hiddenHandles.value = selected.map((s) => s.handle).join(',');
      if (hiddenVariants) hiddenVariants.value = selected.map((s) => s.variantId).join(',');

      const samplesTotal = selected.reduce((acc, s) => acc + (s.priceCents || 0), 0);
      if (samplesTotalEl) samplesTotalEl.textContent = formatMoney(samplesTotal);

      const savings = samplesTotal - kitPriceCents;
      if (savingsRow && savingsAmount) {
        if (count === targetCount && savings > 0) {
          savingsAmount.textContent = formatMoney(savings);
          savingsRow.removeAttribute('hidden');
        } else {
          savingsRow.setAttribute('hidden', '');
        }
      }

      if (submit) {
        const ready = count === targetCount;
        submit.toggleAttribute('disabled', !ready);
        if (ctaText) {
          ctaText.textContent = ready ? labelReady : labelDisabled(targetCount - count);
        }
      }
      renderSelected();
    };

    const isSelected = (handle) => selected.some((s) => s.handle === handle);

    const setPressed = (handle, pressed) => {
      const btn = root.querySelector(`[data-kit-toggle][data-handle="${CSS.escape(handle)}"]`);
      if (btn) btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    };

    const add = (toggle) => {
      const handle = toggle.dataset.handle;
      if (!handle) return false;
      if (selected.length >= targetCount) return false;
      if (isSelected(handle)) return false;
      selected.push({
        handle,
        title: toggle.dataset.title || '',
        vendor: toggle.dataset.vendor || '',
        variantId: toggle.dataset.variantId || '',
        priceCents: parseInt(toggle.dataset.priceCents || '0', 10),
      });
      setPressed(handle, true);
      update();
      return true;
    };

    const remove = (handle) => {
      const idx = selected.findIndex((s) => s.handle === handle);
      if (idx === -1) return;
      selected.splice(idx, 1);
      setPressed(handle, false);
      update();
    };

    root.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-kit-toggle]');
      if (toggle) {
        const handle = toggle.dataset.handle;
        if (!handle) return;
        if (isSelected(handle)) {
          remove(handle);
        } else {
          if (selected.length >= targetCount) {
            toggle.animate(
              [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
              { duration: 240, easing: 'ease-in-out' }
            );
            return;
          }
          add(toggle);
        }
        return;
      }
      const removeBtn = event.target.closest('[data-kit-remove]');
      if (removeBtn) {
        event.preventDefault();
        remove(removeBtn.dataset.kitRemove);
      }
    });

    if (form) {
      form.addEventListener('submit', async (event) => {
        if (selected.length !== targetCount) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        if (submit) {
          submit.classList.add('is-loading');
          submit.setAttribute('disabled', '');
        }

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
          });
          if (!res.ok) throw new Error('cart-add-failed');

          if (typeof window.cartDrawerOpen === 'function') {
            window.cartDrawerOpen();
          } else {
            const opener = document.querySelector('[data-drawer-open="cart-drawer"]');
            if (opener) opener.click();
            else { window.location.href = '/cart'; return; }
          }
          window.dispatchEvent(new CustomEvent('cart-updated'));
        } catch (e) {
          form.submit();
        } finally {
          if (submit) {
            submit.classList.remove('is-loading');
            submit.removeAttribute('disabled');
          }
        }
      });
    }

    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-pdp]');
    if (!root) return;

    const handle = root.dataset.productHandle;
    const crossSellEnabled = root.dataset.crossSellEnabled === 'true';

    // === Galerie carrousel : un track qui glisse horizontalement ===
    const track = root.querySelector('[data-pdp-track]');
    let galleryImages = [];
    const imagesData = root.querySelector('[data-pdp-images]');
    if (imagesData) {
      try { galleryImages = JSON.parse(imagesData.textContent.trim()); } catch (e) { galleryImages = []; }
    }
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    const lightbox = root.querySelector('[data-pdp-lightbox]');
    const lightboxImg = root.querySelector('[data-pdp-lightbox-img]');
    const mainImageWrap = root.querySelector('[data-pdp-main-image]');
    let current = 0;

    function showImage(i) {
      if (!galleryImages.length) return;
      current = (i % galleryImages.length + galleryImages.length) % galleryImages.length;
      if (track) track.style.transform = 'translateX(' + (-current * 100) + '%)';
      const im = galleryImages[current];
      if (lightboxImg && im) {
        lightboxImg.setAttribute('src', im.src);
        lightboxImg.setAttribute('alt', im.alt || '');
      }
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === current));
    }

    thumbs.forEach((thumb, k) => thumb.addEventListener('click', () => showImage(k)));
    root.querySelector('[data-pdp-prev]')?.addEventListener('click', () => showImage(current - 1));
    root.querySelector('[data-pdp-next]')?.addEventListener('click', () => showImage(current + 1));

    // Lightbox / zoom
    if (lightbox) {
      const openLightbox = () => {
        const im = galleryImages[current];
        if (lightboxImg && im) { lightboxImg.setAttribute('src', im.src); lightboxImg.setAttribute('alt', im.alt || ''); }
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      const closeLightbox = () => {
        lightbox.hidden = true;
        document.body.style.overflow = '';
      };
      const mainImgWrap = root.querySelector('[data-pdp-main-image]');
      if (mainImgWrap) mainImgWrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-pdp-prev],[data-pdp-next]')) return;
        openLightbox();
      });
      root.querySelector('[data-pdp-lightbox-close]')?.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
      root.querySelector('[data-pdp-lb-prev]')?.addEventListener('click', () => showImage(current - 1));
      root.querySelector('[data-pdp-lb-next]')?.addEventListener('click', () => showImage(current + 1));
      document.addEventListener('keydown', (e) => {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') showImage(current - 1);
        else if (e.key === 'ArrowRight') showImage(current + 1);
      });
    }

    // Swipe sur l'image principale (mobile)
    if (galleryImages.length > 1) {
      const swipeZone = root.querySelector('[data-pdp-main-image]');
      let startX = null;
      if (swipeZone) {
        swipeZone.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        swipeZone.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) showImage(dx < 0 ? current + 1 : current - 1);
          startX = null;
        }, { passive: true });
      }
    }

    // Variant selection — update price + label state
    const priceCurrent = root.querySelector('[data-pdp-price-current]');
    const priceCompare = root.querySelector('[data-pdp-price-compare]');
    const ctaDefault = root.querySelector('[data-pdp-cta-default]');
    const ctaButton = root.querySelector('[data-pdp-add-to-cart]');

    const formatMoney = (cents) => {
      const value = (parseInt(cents, 10) || 0) / 100;
      return value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
    };

    root.querySelectorAll('[data-pdp-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        const labels = root.querySelectorAll('.pdp__variant');
        labels.forEach((l) => l.classList.remove('is-selected'));
        const label = input.closest('.pdp__variant');
        if (label) label.classList.add('is-selected');

        if (priceCurrent && input.dataset.variantPrice) {
          priceCurrent.textContent = formatMoney(input.dataset.variantPrice);
        }
        if (priceCompare) {
          const cmp = parseInt(input.dataset.variantComparePrice, 10);
          const cur = parseInt(input.dataset.variantPrice, 10);
          if (cmp > cur) {
            priceCompare.textContent = formatMoney(cmp);
            priceCompare.removeAttribute('hidden');
          } else {
            priceCompare.setAttribute('hidden', '');
            priceCompare.textContent = '';
          }
        }
        if (ctaButton && ctaDefault) {
          if (input.dataset.variantAvailable === 'true') {
            ctaButton.removeAttribute('disabled');
            ctaDefault.textContent = ctaButton.dataset.i18nAdd || ctaDefault.textContent;
          } else {
            ctaButton.setAttribute('disabled', '');
            ctaDefault.textContent = ctaButton.dataset.i18nOutOfStock || ctaDefault.textContent;
          }
        }

        // Sync variant id avec les forms paiement express + pay later
        const expressInputs = root.querySelectorAll('[data-pdp-express-variant]');
        expressInputs.forEach((el) => { el.value = input.value; });

        // Notify-me restock : show si variant unavailable
        const notify = root.querySelector('[data-pdp-notify]');
        if (notify) {
          const isAvailable = input.dataset.variantAvailable === 'true';
          if (isAvailable) {
            notify.setAttribute('hidden', '');
          } else {
            notify.removeAttribute('hidden');
            const variantInput = notify.querySelector('[data-pdp-notify-variant]');
            const bodyInput = notify.querySelector('[data-pdp-notify-body]');
            if (variantInput) variantInput.value = input.value;
            if (bodyInput) {
              const label = (input.closest('.pdp__variant') || {}).innerText || '';
              bodyInput.value = `Produit : ${document.querySelector('.pdp__title')?.textContent || ''} — Variant : ${label.trim()} — Variant ID : ${input.value} — URL : ${window.location.href}`;
            }
          }
        }
      });
    });

    // Wishlist toggle
    const WISHLIST_KEY = 'ad-parfumerie-wishlist';
    const wishlistBtn = root.querySelector('[data-pdp-wishlist]');

    const readWishlist = () => {
      try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      } catch (e) {
        return [];
      }
    };
    const writeWishlist = (list) => {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { count: list.length } }));
    };

    const refreshWishlistState = () => {
      if (!wishlistBtn) return;
      const list = readWishlist();
      const isIn = list.includes(handle);
      wishlistBtn.setAttribute('aria-pressed', isIn ? 'true' : 'false');
      wishlistBtn.setAttribute('aria-label', isIn ? (wishlistBtn.dataset.i18nWishlistRemove || '') : (wishlistBtn.dataset.i18nWishlistAdd || ''));
    };

    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', () => {
        const list = readWishlist();
        const idx = list.indexOf(handle);
        if (idx >= 0) {
          list.splice(idx, 1);
        } else {
          list.push(handle);
        }
        writeWishlist(list);
        refreshWishlistState();
      });
      refreshWishlistState();
      window.addEventListener('wishlist-updated', refreshWishlistState);
    }

    // Try Me — separate add-to-cart for the 5 ml sample variant
    const tryMeBtn = root.querySelector('[data-pdp-try-me-trigger]');
    if (tryMeBtn) {
      tryMeBtn.addEventListener('click', async () => {
        if (tryMeBtn.classList.contains('is-loading') || tryMeBtn.hasAttribute('disabled')) return;
        const variantId = parseInt(tryMeBtn.dataset.variantId, 10);
        if (!variantId) return;

        tryMeBtn.classList.add('is-loading');
        tryMeBtn.setAttribute('disabled', '');

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties: { _try_me: 'true' } }],
              sections: ['cart-drawer']
            })
          });
          if (!res.ok) throw new Error('try-me-failed');
          const data = await res.json();
          if (data.sections && data.sections['cart-drawer'] && typeof window.cartDrawerReplace === 'function') {
            window.cartDrawerReplace(data.sections['cart-drawer'], true);
          } else if (typeof window.cartDrawerOpen === 'function') {
            window.cartDrawerOpen();
          }
          window.dispatchEvent(new CustomEvent('cart-updated'));
        } catch (e) {
          window.location.href = '/cart';
        } finally {
          tryMeBtn.classList.remove('is-loading');
          if (variantId) tryMeBtn.removeAttribute('disabled');
        }
      });
    }

    // Sticky add-to-cart desktop card
    const stickyCard = document.querySelector('[data-pdp-sticky]');
    const ctaRow = root.querySelector('.pdp__cta-row');
    const stickyPrice = stickyCard ? stickyCard.querySelector('[data-pdp-sticky-price]') : null;
    const stickyTrigger = stickyCard ? stickyCard.querySelector('[data-pdp-sticky-trigger]') : null;

    if (stickyCard && ctaRow) {
      const desktopMQ = window.matchMedia('(min-width: 1024px)');
      let ctaVisible = true;
      let scrolledEnough = false;

      const sync = () => {
        if (!desktopMQ.matches) {
          stickyCard.classList.remove('is-visible');
          stickyCard.setAttribute('hidden', '');
          return;
        }
        const show = !ctaVisible && scrolledEnough;
        if (show) {
          stickyCard.removeAttribute('hidden');
          requestAnimationFrame(() => stickyCard.classList.add('is-visible'));
        } else {
          stickyCard.classList.remove('is-visible');
        }
      };

      const obs = new IntersectionObserver(
        (entries) => {
          ctaVisible = entries[0].isIntersecting;
          sync();
        },
        { threshold: 0 }
      );
      obs.observe(ctaRow);

      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          scrolledEnough = window.scrollY > 800;
          sync();
          ticking = false;
        });
      }, { passive: true });

      desktopMQ.addEventListener('change', sync);

      if (stickyTrigger) {
        stickyTrigger.addEventListener('click', () => {
          if (ctaButton) ctaButton.click();
        });
      }
    }

    // Variant change → also sync sticky price
    root.querySelectorAll('[data-pdp-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        if (stickyPrice && input.dataset.variantPrice) {
          stickyPrice.textContent = formatMoney(input.dataset.variantPrice);
        }
        if (stickyTrigger) {
          if (input.dataset.variantAvailable === 'true') {
            stickyTrigger.removeAttribute('disabled');
            stickyTrigger.textContent = stickyTrigger.dataset.i18nAdd || stickyTrigger.textContent;
          } else {
            stickyTrigger.setAttribute('disabled', '');
            stickyTrigger.textContent = stickyTrigger.dataset.i18nUnavailable || stickyTrigger.textContent;
          }
        }
      });
    });

    // Add to cart with success animation + drawer open + cross-sell
    const form = root.querySelector('[data-pdp-form]');
    const ctaSuccess = root.querySelector('[data-pdp-cta-success]');

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (ctaButton.hasAttribute('disabled') && !ctaButton.classList.contains('is-loading')) return;

        ctaButton.classList.add('is-loading');
        ctaButton.setAttribute('disabled', '');
        if (stickyTrigger) {
          stickyTrigger.classList.add('is-loading');
          stickyTrigger.setAttribute('disabled', '');
        }

        const formData = new FormData(form);
        const variantId = parseInt(formData.get('id'), 10);
        const quantity = parseInt(formData.get('quantity') || '1', 10);

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity }],
              sections: ['cart-drawer']
            })
          });
          if (!res.ok) throw new Error('cart-add-failed');
          const data = await res.json();

          if (data.sections && data.sections['cart-drawer'] && typeof window.cartDrawerReplace === 'function') {
            window.cartDrawerReplace(data.sections['cart-drawer'], true);
          } else if (typeof window.cartDrawerOpen === 'function') {
            window.cartDrawerOpen();
          } else {
            const opener = document.querySelector('[data-drawer-open="cart-drawer"]');
            if (opener) opener.click();
          }

          if (ctaDefault && ctaSuccess) {
            ctaDefault.setAttribute('hidden', '');
            ctaSuccess.removeAttribute('hidden');
            setTimeout(() => {
              ctaDefault.removeAttribute('hidden');
              ctaSuccess.setAttribute('hidden', '');
            }, 2000);
          }

          window.dispatchEvent(new CustomEvent('cart-updated'));
          if (crossSellEnabled) {
            window.dispatchEvent(new CustomEvent('cross-sell-trigger', { detail: { handle } }));
          }
        } catch (e) {
          form.submit();
        } finally {
          ctaButton.classList.remove('is-loading');
          ctaButton.removeAttribute('disabled');
          if (stickyTrigger) {
            stickyTrigger.classList.remove('is-loading');
            stickyTrigger.removeAttribute('disabled');
          }
        }
      });
    }
  })();

  // Carrousel reco "Vous pourriez aussi aimer" — auto-scroll mobile uniquement
  (function () {
    const track = document.querySelector('[data-pdp-reco-track]');
    if (!track) return;

    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    const stepSize = () => {
      const first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    };

    let timer = null;
    let paused = false;

    const tick = () => {
      if (paused || !isMobile()) return;
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 4) return; // rien à défiler
      if (track.scrollLeft >= max - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      }
    };

    const start = () => {
      if (timer || !isMobile()) return;
      if (track.scrollWidth - track.clientWidth <= 4) return;
      timer = setInterval(tick, 3500);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    // Pause quand l'utilisateur touche/scrolle, reprise après inactivité
    let resumeTimer = null;
    const pauseThenResume = () => {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => { paused = false; }, 5000);
    };
    track.addEventListener('touchstart', pauseThenResume, { passive: true });
    track.addEventListener('pointerdown', pauseThenResume, { passive: true });

    document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });
    window.addEventListener('resize', () => { stop(); start(); });

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maisons-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-maisons-carousel]').forEach(function (root) {
      var scroller = root.querySelector('[data-maisons-marquee]');
      var track = root.querySelector('.maisons__marquee-track');
      var prevBtn = root.querySelector('[data-maisons-prev]');
      var nextBtn = root.querySelector('[data-maisons-next]');
      if (!scroller || !track) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var paused = false;
      var resumeTimer = null;
      var SPEED = 1; // px/frame — défilement lent constant (façon marquee)

      function half() {
        // largeur d'UNE copie = offset de la 1re carte de la 2e copie (indépendant du padding-inline)
        var cells = track.querySelectorAll('.maisons__cell');
        var mid = Math.floor(cells.length / 2);
        if (cells.length >= 2 && cells[mid]) {
          return cells[mid].offsetLeft - cells[0].offsetLeft;
        }
        return scroller.scrollWidth / 2;
      }

      function tick() {
        if (!paused) {
          scroller.scrollLeft += SPEED;
          var h = half();
          if (h > 0 && scroller.scrollLeft >= h) {
            scroller.scrollLeft -= h; // reset seamless (2e copie identique)
          }
        }
        window.requestAnimationFrame(tick);
      }

      function pause(ms) {
        paused = true;
        if (resumeTimer) window.clearTimeout(resumeTimer);
        if (ms && !reduce) {
          resumeTimer = window.setTimeout(function () { paused = false; }, ms);
        }
      }

      function nudge(dir) {
        var cell = track.querySelector('.maisons__cell');
        var step = cell ? cell.getBoundingClientRect().width + 24 : 320;
        var h = half();
        if (h > 0 && scroller.scrollLeft >= h) { scroller.scrollLeft -= h; }
        scroller.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
        pause(3000);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { nudge(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { nudge(1); });

      scroller.addEventListener('pointerenter', function () { paused = true; });
      scroller.addEventListener('pointerleave', function () { if (!reduce) paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { if (!reduce) paused = false; });
      scroller.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      scroller.addEventListener('touchend', function () { pause(3000); }, { passive: true });

      if (!reduce) {
        window.requestAnimationFrame(tick);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DRAWER_NAME = 'mobile-menu';
    const drawer = document.querySelector('[data-drawer="' + DRAWER_NAME + '"]');
    if (!drawer) return;

    const openDrawer = () => {
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
    };

    const closeDrawer = () => {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-drawer-open="' + DRAWER_NAME + '"]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (!drawer.open) return;
      const closer = event.target.closest('[data-drawer-close]');
      if (closer && drawer.contains(closer)) {
        closeDrawer();
        return;
      }
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    // Dropdown langue : ferme au clic en dehors
    drawer.querySelectorAll('[data-mobile-locale]').forEach(function (d) {
      document.addEventListener('click', function (e) {
        if (d.open && !d.contains(e.target)) d.removeAttribute('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-newsletter-popup]');
    if (!root) return;

    const STORAGE_KEY = 'np_seen_v1';
    const scrollPct = parseFloat(root.dataset.triggerScrollPct || '30') / 100;
    const delaySec = parseFloat(root.dataset.triggerDelaySeconds || '25');

    if (localStorage.getItem(STORAGE_KEY)) return;

    let opened = false;

    const open = () => {
      if (opened) return;
      opened = true;
      root.removeAttribute('hidden');
      requestAnimationFrame(() => root.classList.add('is-open'));
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
      const input = root.querySelector('[data-newsletter-input]');
      if (input) {
        setTimeout(() => input.focus(), 280);
      }
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      root.classList.remove('is-open');
      setTimeout(() => {
        root.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }, 280);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0) {
          const pct = window.scrollY / max;
          if (pct >= scrollPct) {
            open();
            window.removeEventListener('scroll', onScroll);
          }
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    setTimeout(open, delaySec * 1000);

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-newsletter-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olfactory-families"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cards = document.querySelectorAll('[data-olfactory-card]');
    if (!cards.length) return;

    const prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const card = entry.target;
          const siblings = Array.from(card.parentElement.children).filter((el) =>
            el.hasAttribute('data-olfactory-card')
          );
          const index = siblings.indexOf(card);
          card.style.setProperty('--delay', index * 100 + 'ms');
          card.classList.add('is-visible');
          observer.unobserve(card);
        });
      },
      { threshold: 0.15 }
    );

    cards.forEach((card) => observer.observe(card));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pills = document.querySelectorAll('[data-faq-pill]');
    const cats = document.querySelectorAll('[data-faq-category]');
    if (!pills.length || !cats.length) return;

    pills.forEach((p) =>
      p.addEventListener('click', (e) => {
        e.preventDefault();
        const id = p.getAttribute('data-faq-pill');
        const target = document.getElementById(id);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const id = entry.target.getAttribute('data-faq-category');
            pills.forEach((p) => {
              const match = p.getAttribute('data-faq-pill') === id;
              if (match) p.setAttribute('aria-current', 'true');
              else p.removeAttribute('aria-current');
            });
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      cats.forEach((c) => obs.observe(c));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-notre-boutique"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var gal = document.querySelector('[data-pb-gallery]');
    var lb = document.querySelector('[data-pb-lb]');
    if (!gal || !lb) return;
    var tiles = Array.prototype.slice.call(gal.querySelectorAll('.page-boutique__tile'));
    if (!tiles.length) return;
    var imgEl = lb.querySelector('[data-pb-img]');
    var capEl = lb.querySelector('[data-pb-caption]');
    var cntEl = lb.querySelector('[data-pb-count]');
    var closeBtn = lb.querySelector('[data-pb-close]');
    var prevBtn = lb.querySelector('[data-pb-prev]');
    var nextBtn = lb.querySelector('[data-pb-next]');
    var index = 0;
    var lastFocus = null;

    function render() {
      var img = tiles[index].querySelector('img');
      imgEl.src = img.currentSrc || img.src;
      imgEl.alt = img.getAttribute('data-pb-alt') || '';
      capEl.textContent = img.getAttribute('data-pb-kw') || '';
      cntEl.textContent = index + 1 + ' / ' + tiles.length;
    }
    function open(i) {
      index = i;
      lastFocus = document.activeElement;
      render();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function close() {
      lb.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function step(d) {
      index = (index + d + tiles.length) % tiles.length;
      render();
    }

    tiles.forEach(function (t, i) {
      t.addEventListener('click', function () { open(i); });
    });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });

    // Swipe (mobile)
    var startX = 0;
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) startX = e.touches[0].clientX;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 48) step(dx > 0 ? -1 : 1);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  (function () {
    const DRAWER_NAME = 'search';
    const drawer = document.querySelector('[data-drawer="' + DRAWER_NAME + '"]');
    if (!drawer) return;

    const i18n = {
      noResults: drawer.getAttribute('data-i18n-no-results') || 'Aucun résultat pour « %s »',
      groupProducts: drawer.getAttribute('data-i18n-group-products') || 'Parfums',
      groupCollections: drawer.getAttribute('data-i18n-group-collections') || 'Maisons & collections',
      groupPages: drawer.getAttribute('data-i18n-group-pages') || 'Pages',
      viewAll: drawer.getAttribute('data-i18n-view-all') || 'Voir tous les résultats →',
      loading: drawer.getAttribute('data-i18n-loading') || 'Recherche…'
    };

    const input = drawer.querySelector('[data-search-input]');

    const openDrawer = () => {
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      if (input) {
        requestAnimationFrame(() => input.focus());
      }
    };

    const closeDrawer = () => {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-drawer-open="' + DRAWER_NAME + '"]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (!drawer.open) return;
      const closer = event.target.closest('[data-drawer-close]');
      if (closer && drawer.contains(closer)) {
        closeDrawer();
        return;
      }
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    // === Recherche live (predictive search) ===
    const resultsEl = drawer.querySelector('[data-search-results]');
    const suggestionsEl = drawer.querySelector('[data-search-suggestions]');
    let debounceId = null;
    let lastReq = 0;

    function esc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function money(p) {
      if (p == null || p === '') return '';
      const n = parseFloat(p);
      if (isNaN(n)) return '';
      return '€' + n.toFixed(2).replace('.', ',');
    }
    function allUrl(q) { return '/search?type=product%2Carticle%2Cpage%2Ccollection&q=' + encodeURIComponent(q); }

    function showSuggestions() {
      if (resultsEl) { resultsEl.hidden = true; resultsEl.innerHTML = ''; }
      if (suggestionsEl) suggestionsEl.hidden = false;
    }

    function render(q, res) {
      const prods = (res.products || []).slice(0, 6);
      const cols = (res.collections || []).slice(0, 4);
      const pages = (res.pages || []).slice(0, 3);
      let html = '';
      if (!prods.length && !cols.length && !pages.length) {
        html = '<p class="search-drawer__empty">' + i18n.noResults.replace('%s', esc(q)) + '</p>';
      } else {
        if (prods.length) {
          html += '<div class="search-drawer__group"><span class="search-drawer__group-title">' + esc(i18n.groupProducts) + '</span><ul class="search-drawer__list">';
          prods.forEach(function (p) {
            const img = (p.featured_image && p.featured_image.url) || p.image;
            const media = img ? '<img src="' + img + '" alt="" loading="lazy" width="48" height="60">' : '';
            html += '<li><a class="search-drawer__result" href="' + p.url + '">'
              + '<span class="search-drawer__result-media">' + media + '</span>'
              + '<span class="search-drawer__result-text">'
              + (p.vendor ? '<span class="search-drawer__result-brand">' + esc(p.vendor) + '</span>' : '')
              + '<span class="search-drawer__result-title">' + esc(p.title) + '</span></span>'
              + '<span class="search-drawer__result-price">' + money(p.price) + '</span></a></li>';
          });
          html += '</ul></div>';
        }
        if (cols.length) {
          html += '<div class="search-drawer__group"><span class="search-drawer__group-title">' + esc(i18n.groupCollections) + '</span><ul class="search-drawer__list search-drawer__list--text">';
          cols.forEach(function (c) { html += '<li><a class="search-drawer__link" href="' + c.url + '">' + esc(c.title) + '</a></li>'; });
          html += '</ul></div>';
        }
        if (pages.length) {
          html += '<div class="search-drawer__group"><span class="search-drawer__group-title">' + esc(i18n.groupPages) + '</span><ul class="search-drawer__list search-drawer__list--text">';
          pages.forEach(function (pg) { html += '<li><a class="search-drawer__link" href="' + pg.url + '">' + esc(pg.title) + '</a></li>'; });
          html += '</ul></div>';
        }
        html += '<a class="search-drawer__viewall" href="' + allUrl(q) + '">' + esc(i18n.viewAll) + '</a>';
      }
      resultsEl.innerHTML = html;
    }

    function runSearch(q) {
      if (suggestionsEl) suggestionsEl.hidden = true;
      resultsEl.hidden = false;
      resultsEl.innerHTML = '<p class="search-drawer__loading">' + esc(i18n.loading) + '</p>';
      const reqId = ++lastReq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (reqId !== lastReq) return; // ignore réponses obsolètes
          render(q, (j.resources && j.resources.results) || {});
        })
        .catch(function () { if (reqId === lastReq) showSuggestions(); });
    }

    if (input && resultsEl) {
      input.addEventListener('input', function () {
        const q = input.value.trim();
        clearTimeout(debounceId);
        if (q.length < 2) { showSuggestions(); return; }
        debounceId = setTimeout(function () { runSearch(q); }, 220);
      });
      drawer.addEventListener('close', function () {
        input.value = '';
        showSuggestions();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta-bar"]) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-sticky-cta-bar]');
    if (!bar) return;

    const desktopMQ = window.matchMedia('(min-width: 768px)');
    if (desktopMQ.matches) return;

    const SCROLL_TRIGGER_PX = 600;
    const hero = document.querySelector('[data-hero], .hero');
    const footer = document.querySelector('[data-footer], footer');

    let heroVisible = !!hero;
    let scrolledPast = false;
    let footerVisible = false;

    const update = () => {
      let shouldShow;
      if (hero) {
        shouldShow = !heroVisible && !footerVisible;
      } else {
        shouldShow = scrolledPast && !footerVisible;
      }
      bar.classList.toggle('is-visible', shouldShow);
    };

    if (hero) {
      const heroObs = new IntersectionObserver(
        (entries) => {
          heroVisible = entries[0].isIntersecting;
          update();
        },
        { threshold: 0, rootMargin: '0px 0px -80px 0px' }
      );
      heroObs.observe(hero);
    } else {
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          scrolledPast = window.scrollY > SCROLL_TRIGGER_PX;
          update();
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (footer) {
      const footerObs = new IntersectionObserver(
        (entries) => {
          footerVisible = entries[0].isIntersecting;
          update();
        },
        { threshold: 0 }
      );
      footerObs.observe(footer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-us"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const targets = document.querySelectorAll('[data-why-anim]');
    if (!targets.length) return;

    const reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const intersecting = entries.filter((e) => e.isIntersecting);
        intersecting.forEach((entry, i) => {
          const el = entry.target;
          el.style.setProperty('--delay', i * 150 + 'ms');
          el.classList.add('is-visible');
          observer.unobserve(el);
        });
      },
      { threshold: 0.15 }
    );

    targets.forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-wishlist]');
    if (!root) return;

    const STORAGE_KEY = 'ad-parfumerie-wishlist';
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const counter = root.querySelector('[data-wishlist-count]');

    const i18n = {
      countOne: root.dataset.i18nCountOne || '1 parfum',
      countOther: root.dataset.i18nCountOther || '2 parfums',
      from: root.dataset.i18nFrom || 'À partir de',
      remove: root.dataset.i18nRemove || 'Retirer de la wishlist',
      loading: root.dataset.i18nLoading || 'Chargement de vos favoris…',
    };

    const readWishlist = () => {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    };
    const writeWishlist = (list) => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { count: list.length } }));
    };

    const formatMoney = (cents) => {
      const value = (parseInt(cents, 10) || 0) / 100;
      return value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
    };

    const updateCounter = (n) => {
      if (!counter) return;
      const template = n > 1 ? i18n.countOther : i18n.countOne;
      counter.textContent = template.replace(/\d+/, n);
    };

    const renderCard = (product, handle) => {
      const item = document.createElement('div');
      item.className = 'wishlist__item';
      item.setAttribute('role', 'listitem');
      item.dataset.handle = handle;

      const compareHtml = product.compare_at_price && product.compare_at_price > product.price
        ? '<span class="product-card__price-compare">' + formatMoney(product.compare_at_price) + '</span>'
        : '';

      const variant = product.variants && product.variants[0];
      const sizeHtml = variant && variant.title && variant.title !== 'Default Title'
        ? '<span class="product-card__price-size">' + i18n.from + ' ' + formatMoney(variant.price) + ' · ' + variant.title + '</span>'
        : '';

      const imgUrl = product.featured_image
        ? (product.featured_image.indexOf('http') === 0 ? product.featured_image : 'https:' + product.featured_image)
        : '';

      item.innerHTML = ''
        + '<button class="wishlist__remove" type="button" aria-label="' + i18n.remove + '" data-wishlist-remove>'
        + '  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">'
        + '    <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>'
        + '  </svg>'
        + '</button>'
        + '<article class="product-card" data-product-card>'
        + '  <a href="/products/' + handle + '" class="product-card__link" aria-label="' + product.title + '">'
        + '    <div class="product-card__media">'
        + (imgUrl ? '<img class="product-card__image" src="' + imgUrl + '" alt="' + product.title + '" loading="lazy">' : '<div class="product-card__placeholder-img"></div>')
        + '    </div>'
        + '    <div class="product-card__body">'
        + (product.vendor ? '<span class="product-card__brand">' + product.vendor + '</span>' : '')
        + '      <h3 class="product-card__title">' + product.title + '</h3>'
        + '      <div class="product-card__price">'
        + '        <span class="product-card__price-current">' + formatMoney(product.price) + '</span>'
        + compareHtml
        + '      </div>'
        + sizeHtml
        + '    </div>'
        + '  </a>'
        + '</article>';

      const removeBtn = item.querySelector('[data-wishlist-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          const list = readWishlist().filter((h) => h !== handle);
          writeWishlist(list);
          item.remove();
          updateCounter(list.length);
          if (list.length === 0) {
            empty.removeAttribute('hidden');
            grid.setAttribute('hidden', '');
          }
        });
      }

      return item;
    };

    const render = async () => {
      const handles = readWishlist();
      updateCounter(handles.length);

      if (handles.length === 0) {
        empty.removeAttribute('hidden');
        grid.setAttribute('hidden', '');
        return;
      }

      empty.setAttribute('hidden', '');
      grid.removeAttribute('hidden');
      grid.innerHTML = '<div class="wishlist__loader">' + i18n.loading + '</div>';

      const fetched = await Promise.all(handles.map(async (handle) => {
        try {
          const res = await fetch('/products/' + handle + '.js');
          if (!res.ok) return null;
          const data = await res.json();
          return { handle, data };
        } catch (e) {
          return null;
        }
      }));

      grid.innerHTML = '';
      fetched.forEach((entry) => {
        if (!entry) return;
        grid.appendChild(renderCard(entry.data, entry.handle));
      });

      // If after filtering nothing valid remained
      if (grid.children.length === 0) {
        empty.removeAttribute('hidden');
        grid.setAttribute('hidden', '');
      }
    };

    render();

    window.addEventListener('wishlist-updated', () => {
      // Re-render on external changes (eg. add from another tab)
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
